export const DisplayValues = {
  ViewForm: {
    English: {
      Active: "Viewing form in English",
      Inactive: "View form in English",
      Admin: "English",
    },
    French: {
      Active: "Visualisation le formulaire en Français",
      Inactive: "Voir le formulaire en Français",
      Admin: "Français",
    },
  },
}
